import styled from 'styled-components';

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: ${({ $compact }) => ($compact ? '34px' : '68px')};
  height: ${({ $compact }) => ($compact ? '14px' : '22px')};
  padding: ${({ $compact }) => ($compact ? '0 6px' : '0 10px')};
  border-radius: 999px;
  background-color: ${({ theme }) => theme.buttons.primary.background};
  color: ${({ theme }) => theme.buttons.primary.color};
  font-size: ${({ $compact }) => ($compact ? '8px' : '11px')};
  font-weight: 365;
  line-height: 1;
  letter-spacing: 0;
  white-space: nowrap;
  pointer-events: none;
  position: ${({ $compact }) => ($compact ? 'absolute' : 'relative')};;
  left: ${({ $compact }) => ($compact ? '-20px' : '0')};
`;

export default Wrapper;
